document.addEventListener('DOMContentLoaded', async () => {
  const config = window.mainSearchQuickFilterConfig || {};
  const sectionId = config.sectionId;

  if (!sectionId) return;

  const form = document.getElementById(`search-quick-filters-form-${sectionId}`);
  const brandSelect = document.getElementById(`search-brand-select-${sectionId}`);
  const modelSelect = document.getElementById(`search-model-select-${sectionId}`);
  const brandTrigger = document.getElementById(`search-brand-select-value-${sectionId}`);
  const modelTrigger = document.getElementById(`search-model-select-value-${sectionId}`);
  const submitBtn = document.getElementById(`search-submit-btn-filter-${sectionId}`);
  const clearBtn = document.getElementById(`search-clear-btn-filter-${sectionId}`);

  if (!form || !brandSelect || !modelSelect || !brandTrigger || !modelTrigger || !submitBtn || !clearBtn) return;

  function getCurrentParams() {
    return new URLSearchParams(window.location.search);
  }

  function getSelectedBrandFromURL() {
    return getCurrentParams().get(config.brandParam) || '';
  }

  function getSelectedModelFromURL() {
    return getCurrentParams().get(config.modelParam) || '';
  }

  function showLoadingSpinner(selectElement) {
    const optionsContainer = selectElement.querySelector('.custom-options');
    optionsContainer.innerHTML =
      '<li class="custom-option loading-spinner"> <div id="loadingSpinner">\n' +
      '      <span class="spinner"></span>\n' +
      '    </div></li>';
  }

  function hideLoadingSpinner(selectElement) {
    const optionsContainer = selectElement.querySelector('.custom-options');
    const spinner = optionsContainer.querySelector('.loading-spinner');
    if (spinner) spinner.remove();
  }

  function clearSearchInputs() {
    document
      .querySelectorAll(
        `#search-brand-select-${sectionId} .search-input, #search-model-select-${sectionId} .search-input`
      )
      .forEach((input) => {
        input.value = '';
      });
  }

  function closeAllSelects() {
    document.querySelectorAll(`#search-brand-select-${sectionId}, #search-model-select-${sectionId}`).forEach((select) => {
      select.classList.remove('open');
      const trigger = select.querySelector('.custom-select-trigger');
      const searchInput = select.querySelector('.search-input');
      trigger.style.display = 'block';
      searchInput.style.display = 'none';
    });
  }

  function filterOptions(select, searchTerm) {
    select.querySelectorAll('.custom-option').forEach((option) => {
      option.classList.toggle('hidden', !option.textContent.toLowerCase().includes(searchTerm));
    });
  }

  function buildBaseParams() {
    const params = getCurrentParams();

    if (!params.has('q')) params.set('q', config.terms || '');
    if (!params.has('options[prefix]')) params.set('options[prefix]', 'last');
    if (!params.has('sort_by') && config.sortBy) params.set('sort_by', config.sortBy);

    params.delete(config.brandParam);
    params.delete(config.modelParam);
    params.delete('page');

    return params;
  }

  function normalizeToArray(value) {
    if (Array.isArray(value)) return value;
    if (value === null || value === undefined || value === '') return [];
    return [value];
  }

  function buildFallbackBrandModelData() {
    const map = {};

    brandSelect.querySelectorAll('.custom-option').forEach((option) => {
      const brand = option.dataset.value;
      if (brand) {
        map[brand] = [];
      }
    });

    return map;
  }

  const fallbackBrandModelData = buildFallbackBrandModelData();

  function resetFiltersUI() {
    brandTrigger.textContent = config.brandText;
    brandTrigger.dataset.value = '';
    brandTrigger.style.display = 'block';

    modelTrigger.textContent = config.modelText;
    modelTrigger.dataset.value = '';
    modelTrigger.style.display = 'block';

    brandSelect.classList.remove('open');
    brandSelect.querySelectorAll('.custom-option').forEach((option) => {
      option.classList.remove('selected', 'hidden');
    });

    modelSelect.classList.remove('open');
    modelSelect.classList.add('disabled');
    modelSelect.querySelector('.custom-options').innerHTML = '';

    clearSearchInputs();

    document
      .querySelectorAll(
        `#search-brand-select-${sectionId} .search-input, #search-model-select-${sectionId} .search-input`
      )
      .forEach((input) => {
        input.style.display = 'none';
      });

    submitBtn.setAttribute('disabled', 'disabled');
  }

  async function updateModels(selectedBrand) {
    const customOptions = modelSelect.querySelector('.custom-options');

    modelSelect.classList.remove('open');
    customOptions.innerHTML = '';

    if (!selectedBrand) {
      modelSelect.classList.add('disabled');
      submitBtn.setAttribute('disabled', 'disabled');
      modelTrigger.textContent = config.modelText;
      modelTrigger.dataset.value = '';
      return;
    }

    modelSelect.classList.remove('disabled');
    submitBtn.removeAttribute('disabled');
    showLoadingSpinner(modelSelect);

    let models = [];

    if (typeof window.fetchModelsBySearchTermAndBrand === 'function') {
      models = await window.fetchModelsBySearchTermAndBrand(config.terms, selectedBrand);
    } else {
      models = (fallbackBrandModelData[selectedBrand] || []).map((model) => [model]);
    }

    hideLoadingSpinner(modelSelect);

    models
      .map((model) => Array.isArray(model) ? model[0] : model)
      .filter(Boolean)
      .forEach((model) => {
      const option = document.createElement('li');
      option.className = 'custom-option';
      option.dataset.value = model;
      option.textContent = model;
      customOptions.appendChild(option);
      });

    const currentModelValue = modelTrigger.dataset.value;
    clearSearchInputs();

    if (currentModelValue) {
      const selectedModelOption = customOptions.querySelector(`.custom-option[data-value="${CSS.escape(currentModelValue)}"]`);
      if (selectedModelOption) {
        selectedModelOption.classList.add('selected');
      } else {
        modelTrigger.textContent = config.modelText;
        modelTrigger.dataset.value = '';
      }
    } else {
      modelTrigger.textContent = config.modelText;
      modelTrigger.dataset.value = '';
    }

    const trigger = modelSelect.querySelector('.custom-select-trigger');
    const searchInput = modelSelect.querySelector('.search-input');
    trigger.style.display = 'block';
    searchInput.style.display = 'none';
  }

  async function initializeFilters() {
    const brandOptions = brandSelect.querySelector('.custom-options');
    const selectedBrand = getSelectedBrandFromURL();
    const selectedModel = getSelectedModelFromURL();
    const availableBrandOptions = brandOptions.querySelectorAll('.custom-option');

    if (selectedBrand) {
      const selectedBrandOption = brandOptions.querySelector(`.custom-option[data-value="${CSS.escape(selectedBrand)}"]`);
      if (selectedBrandOption) {
        selectedBrandOption.classList.add('selected');
        brandTrigger.textContent = selectedBrandOption.textContent;
        brandTrigger.dataset.value = selectedBrand;
      }

      if (selectedModel) {
        modelTrigger.textContent = selectedModel;
        modelTrigger.dataset.value = selectedModel;
      }

      if (modelSelect.querySelectorAll('.custom-options .custom-option').length === 0) {
        await updateModels(selectedBrand);
      } else {
        modelSelect.classList.remove('disabled');
        submitBtn.removeAttribute('disabled');
        const selectedModelOption = modelSelect.querySelector(`.custom-option[data-value="${CSS.escape(selectedModel)}"]`);
        if (selectedModelOption) selectedModelOption.classList.add('selected');
      }
    } else if (availableBrandOptions.length === 1) {
      const onlyBrandOption = availableBrandOptions[0];
      onlyBrandOption.classList.add('selected');
      brandTrigger.textContent = onlyBrandOption.textContent;
      brandTrigger.dataset.value = onlyBrandOption.dataset.value;
      await updateModels(onlyBrandOption.dataset.value);
    } else {
      resetFiltersUI();
    }
  }

  document.addEventListener('click', async (event) => {
    const trigger = event.target.closest(
      `#search-brand-select-${sectionId} .custom-select-trigger, #search-model-select-${sectionId} .custom-select-trigger`
    );

    if (trigger) {
      const select = trigger.closest('.custom-select');

      if (select.classList.contains('disabled')) return;

      const searchInput = select.querySelector('.search-input');
      closeAllSelects();
      select.classList.add('open');
      trigger.style.display = 'none';
      searchInput.style.display = 'block';
      searchInput.value = '';
      filterOptions(select, '');
      searchInput.focus();
      return;
    }

    const option = event.target.closest(
      `#search-brand-select-${sectionId} .custom-option, #search-model-select-${sectionId} .custom-option`
    );

    if (option) {
      const select = option.closest('.custom-select');
      const triggerElement = select.querySelector('.custom-select-trigger');
      const searchInput = select.querySelector('.search-input');

      triggerElement.textContent = option.textContent;
      triggerElement.dataset.value = option.dataset.value;
      triggerElement.style.display = 'block';
      searchInput.style.display = 'none';

      select.querySelectorAll('.custom-option').forEach((selectOption) => selectOption.classList.remove('selected'));
      option.classList.add('selected');
      select.classList.remove('open');

      if (select.id === `search-brand-select-${sectionId}`) {
        modelTrigger.textContent = config.modelText;
        modelTrigger.dataset.value = '';
        await updateModels(option.dataset.value);
      }

      return;
    }

    if (!event.target.classList.contains('search-input')) {
      closeAllSelects();
    }
  });

  document
    .querySelectorAll(`#search-brand-select-${sectionId} .search-input, #search-model-select-${sectionId} .search-input`)
    .forEach((input) => {
      input.addEventListener('input', (event) => {
        const select = event.target.closest('.custom-select');
        filterOptions(select, event.target.value.toLowerCase());
      });
    });

  form.addEventListener('submit', (event) => {
    event.preventDefault();

    const params = buildBaseParams();
    const brand = brandTrigger.dataset.value;
    const model = modelTrigger.dataset.value;

    if (brand) params.set(config.brandParam, brand);
    if (model) params.set(config.modelParam, model);

    window.location.href = `${config.searchUrl}?${params.toString()}`;
  });

  clearBtn.addEventListener('click', () => {
    resetFiltersUI();
    const params = buildBaseParams();
    window.location.href = `${config.searchUrl}?${params.toString()}`;
  });

  await initializeFilters();
});
